var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 449,
    viewBox: "0 0 375 449",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_942_2596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.890625V339.47C0 339.47 32.2351 400.704 115.112 393.598C197.989 386.492 215.177 348.221 315.243 418.754C315.243 418.754 350.543 448.274 415 447.189V-0.890625H0Z",
    fill: "#6CCEAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.149 449C349.355 449 318.072 427.318 317.738 427.068C255.185 383.288 216.838 391.637 163.778 403.21C149.705 406.278 135.138 409.454 118.529 412.118C37.3493 425.153 -2.59944 387.236 -3 386.844L-2.01196 386.047C-1.62476 386.427 37.8967 423.857 118.275 410.952C134.858 408.288 149.385 405.124 163.444 402.056C216.878 390.412 255.478 382.003 318.553 426.141C318.94 426.414 356.899 452.699 419.853 447.002L419.987 448.18C413.805 448.751 407.85 449 402.149 449Z",
    fill: "#6CCEAB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_942_2596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 423,
    height: 449,
    fill: "white",
    transform: "translate(-3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveSolid);
export default __webpack_public_path__ + "static/media/wave_solid.494061ef93b4cf012fa0122db303781e.svg";
export { ForwardRef as ReactComponent };